import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
	root: {
		backgroundColor: theme.palette.common.white,
		boxShadow: theme.shadows[1]
	},
	toolbar: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	adminPanel: {
		color: 'black'
	},
	flexGrow: {
		flexGrow: 1
	},
	logoutButton: {
		marginLeft: theme.spacing(1)
	},
	menuSection: {
		width: 140,
		display: 'flex',
		justifyContent: 'flex-end'
	}
}));